export default {
    common: {
        email: 'E-mail',
        password: 'Heslo',
        passwordConfirmation: 'Potvrdenie hesla',
        name: 'Meno',
        save: 'Uložiť',
        cancel: 'Zrušiť',
        edit: 'Upraviť',
        delete: 'Zmazať',
        create: 'Vytvoriť',
        back: 'Späť',
        close: 'Zavrieť',
        yes: 'Áno',
        no: 'Nie',
        loading: 'Načítava sa…',
        actions: 'Akcie',
        saving: 'Ukladám...',
        creating: 'Vytváram...',
        saved: 'Uložené.',
    },
    nav: {
        dashboard: 'Prehľad',
        invoices: 'Faktúry',
        recipients: 'Klienti',
        automatizations: 'Automatizácie',
        profile: 'Profil',
        logout: 'Odhlásiť sa',
        openMenu: 'Otvoriť menu',
        admin: 'Admin',
    },
    auth: {
        login: {
            title: 'Prihlásenie',
            password: 'Heslo',
            rememberMe: 'Zapamätať si ma',
            noAccount: 'Nemáte účet?',
            forgotPassword: 'Zabudli ste heslo?',
            submit: 'Prihlásiť sa',
        },
        register: {
            title: 'Registrácia',
            hasAccount: 'Už máte účet?',
            submit: 'Registrovať sa',
        },
        forgotPassword: {
            title: 'Zabudnuté heslo',
            description: 'Zabudli ste heslo? Žiadny problém. Zadajte svoju e-mailovú adresu a pošleme vám odkaz na obnovenie hesla.',
            submit: 'Poslať odkaz na obnovenie hesla',
        },
        resetPassword: {
            title: 'Obnovenie hesla',
            submit: 'Obnoviť heslo',
        },
        confirmPassword: {
            title: 'Potvrdenie hesla',
            description: 'Ide o zabezpečenú časť aplikácie. Pred pokračovaním prosím zadajte heslo.',
            submit: 'Potvrdiť',
        },
        verifyEmail: {
            title: 'Overenie e-mailu',
            description: 'Ďakujeme za registráciu! Pred začatím prosím overte svoju e-mailovú adresu kliknutím na odkaz v e-maile, ktorý sme vám práve poslali. Ak ste e-mail nedostali, radi vám pošleme ďalší.',
            linkSent: 'Nový overovací odkaz bol odoslaný na e-mailovú adresu zadanú pri registrácii.',
            submit: 'Znova poslať overovací e-mail',
        },
    },
    invoiceStatus: {
        draft: 'Koncept',
        sent: 'Odoslaná',
        paid: 'Uhradená',
        overdue: 'Po splatnosti',
    },
    dashboard: {
        title: 'Prehľad',
        welcomeBack: 'Vitaj späť, {name}.',
        stats: {
            invoices: 'Faktúry',
            clients: 'Klienti',
            automatizationsActive: 'Aktívne automatizácie',
            totalInSystem: 'celkom v systéme',
            runAutomatically: 'bežia automaticky',
        },
        pie: {
            title: 'Fakturované podľa stavu',
            subtitle: 'Rozdelenie celkovej fakturovanej sumy',
            empty: 'Zatiaľ nemáš žiadne sumy na rozdelenie.',
            invoiced: 'fakturované',
            paid: 'Uhradené',
            awaiting: 'Čaká na úhradu',
            overdue: 'Po splatnosti',
            draft: 'Koncept',
        },
        overview: {
            totalInvoiced: 'Vyfakturované',
            paid: 'Uhradené',
            awaiting: 'Čaká na úhradu',
            overdue: 'Po splatnosti',
        },
        recentInvoices: {
            title: 'Posledné faktúry',
            viewAll: 'Zobraziť všetky',
            empty: 'Zatiaľ tu nie sú žiadne faktúry.',
        },
        activeAutomatizations: {
            title: 'Aktívne automatizácie',
            manage: 'Spravovať',
            empty: 'Zatiaľ nemáš žiadne aktívne automatizácie.',
            allClients: 'Pre všetkých klientov',
            next: 'Ďalšie',
            active: 'Aktívne',
        },
    },
    automatizations: {
        pageTitle: 'Automatizácie',
        newAutomatization: 'Nová automatizácia',
        emptyState: 'Zatiaľ nemáte žiadne automatizácie. Vytvorte jednu na automatické generovanie faktúr alebo mesačný report.',
        backToAutomatizations: 'Späť na automatizácie',
        deleteConfirm: 'Zmazať automatizáciu „{label}"?',
        list: {
            type: 'Typ',
            client: 'Klient',
            nextRun: 'Nasledujúce spustenie',
            status: 'Stav',
            active: 'Aktívne',
            inactive: 'Neaktívne',
            activate: 'Aktivovať',
            deactivate: 'Deaktivovať',
        },
        form: {
            newTitle: 'Nová automatizácia',
            editTitle: 'Upraviť automatizáciu',
            modalDescription: 'Nastavte automatické akcie pre vaše faktúry.',
            typeSection: 'Typ automatizácie',
            settingsSection: 'Nastavenia',
            type: 'Typ',
            typeLabel: 'Typ:',
            itemCount: 'Počet položiek vo faktúre',
            itemNames: 'Názov položiek',
            client: 'Klient',
            selectClient: 'Vyberte klienta',
            firstRunDate: 'Dátum prvého spustenia',
            reportHint: 'Report je za predošlý mesiac od tohto dátumu.',
            dailyHint: 'Táto automatizácia sa spúšťa denne od dnešného dňa.',
            dueOffsetDays: 'Koľko dní pred/po splatnosti',
            dueOffsetHintBefore: '- pred splatnosťou',
            dueOffsetHintAfter: '+ po splatnosti',
            dueOffsetHintOnDate: '0 v deň splatnosti',
            active: 'Aktívne',
            saveAutomatization: 'Uložiť',
            createAutomatization: 'Vytvoriť automatizáciu',
        },
    },
    invoices: {
        pageTitle: 'Faktúry',
        newInvoice: 'Nová faktúra',
        backToInvoices: 'Späť na faktúry',
        table: {
            number: 'Číslo faktúry',
            client: 'Klient',
            created: 'Vytvorené',
            amount: 'Suma',
            status: 'Stav',
            downloadPdf: 'Stiahnuť PDF',
            empty: 'Zatiaľ nemáte žiadne faktúry.',
            deleteConfirm: 'Zmazať faktúru {number}?',
        },
        header: {
            title: 'Faktúra',
            description: 'Číslo, variabilný symbol a dátumy.',
            number: 'Číslo faktúry',
            variableSymbol: 'Variabilný symbol',
            issueDate: 'Dátum vystavenia',
            dueDate: 'Dátum splatnosti',
            currency: 'Mena',
        },
        sections: {
            basicData: 'Základné údaje',
            client: 'Klient',
            items: 'Položky faktúry',
        },
        recipient: {
            title: 'Klient',
            selectClient: 'Vyberte klienta',
            startTyping: 'Začnite písať...',
            addNewClient: '+ Pridať nového klienta',
            descriptionEdit: 'Vyhľadajte a vyberte klienta alebo upravte údaje nižšie.',
            descriptionCreate: 'Vyhľadajte a vyberte klienta alebo pridajte nového.',
        },
        items: {
            title: 'Položky faktúry',
            description: 'Pridajte jednu alebo viac položiek s názvom, množstvom, jednotkou a cenou.',
            addItem: 'Pridať položku',
            name: 'Názov',
            quantity: 'Množstvo',
            unit: 'Jednotka',
            unitPrice: 'Jednotková cena',
            vatType: 'Typ DPH',
            amountExclVat: 'Suma bez DPH',
            vat: 'DPH',
            total: 'Celkom',
            remove: 'Odstrániť',
            removeRow: 'Odstrániť riadok',
            subtotal: 'Medzisúčet (bez DPH)',
            vatBase: 'Základ DPH:',
            vatLabel: 'DPH:',
            flatDescription: 'Popis položky',
            qtyShort: 'Mn.',
            unitShort: 'Jednotka',
            unitShortMobile: 'Jedn.',
            pricePerUnit: 'Cena / j.',
            totalShort: 'Spolu',
        },
        issuer: {
            title: 'Fakturačné údaje',
            description: 'Adresa vystaviteľa na faktúre.',
            name: 'Názov / firma',
            companyRegNo: 'IČO',
            taxId: 'DIČ',
            vatId: 'IČ DPH',
            street: 'Ulica',
            streetNum: 'Číslo',
            city: 'Mesto',
            zip: 'PSČ',
            country: 'Krajina',
            selectCountry: 'Vyberte krajinu',
        },
        settings: {
            logoUploaded: 'Logo nahraté',
            noLogo: 'Žiadne logo',
            uploadHint: 'Kliknite na plochu a vyberte súbor.',
            removeLogo: 'Odstrániť logo',
            noLogoInvoiceHint: 'Žiadne logo. Pridajte ho v profile v sekcii Nastavenia faktúry.',
            companyLogoAlt: 'Logo firmy',
        },
        form: {
            newInvoice: 'Nová faktúra',
            editInvoice: 'Upraviť faktúru {number}',
            saveInvoice: 'Uložiť faktúru',
            createInvoice: 'Vytvoriť faktúru',
        },
    },
    recipients: {
        pageTitle: 'Klienti',
        newClient: 'Nový klient',
        totalCount: '{count} klientov celkom',
        searchPlaceholder: 'Vyhľadať klienta...',
        backToRecipients: 'Späť na klientov',
        table: {
            client: 'KLIENT',
            ico: 'IČO',
            city: 'MESTO',
            invoices: 'FAKTÚRY',
            invoiced: 'FAKTUROVANÉ',
            noResults: 'Žiadny klient nezodpovedá vyhľadávaniu.',
            empty: 'Zatiaľ nemáte žiadnych klientov.',
            deleteConfirm: 'Zmazať „{name}"?',
        },
        card: {
            city: 'Mesto',
            street: 'Ulica',
            streetNum: 'Číslo',
        },
        details: {
            sectionTitle: 'Údaje o klientovi',
            sectionDescription: 'Názov, adresa a identifikátory klienta.',
            name: 'Názov / obchodné meno',
            street: 'Ulica',
            streetNum: 'Číslo ulice',
            city: 'Mesto',
            zip: 'PSČ',
            country: 'Krajina',
            stateOrZip: 'Štát / PSČ',
            ico: 'IČO',
            dic: 'DIČ',
            icDph: 'IČ DPH',
            iban: 'IBAN',
            selectCountry: 'Vyberte krajinu',
        },
        modal: {
            newTitle: 'Nový klient',
            editTitle: 'Upraviť klienta',
            description: 'Zadajte fakturačné a kontaktné údaje.',
            companyDetails: 'Firemné údaje',
            address: 'Adresa',
            companyName: 'Názov firmy',
            email: 'Email',
            icDphHint: 'Vyplňte len ak je firma platiteľom DPH.',
        },
        form: {
            newTitle: 'Nový klient',
            editTitle: 'Upraviť: {name}',
            defaultName: 'Klient',
            saveClient: 'Uložiť klienta',
            createClient: 'Vytvoriť klienta',
        },
    },
    profile: {
        pageTitle: 'Profil',
        billing: {
            title: 'Fakturačné údaje',
            description: 'Údaje vystaviteľa na faktúrach (adresa, identifikátory, platobný účet).',
            defaultCurrency: 'Predvolená mena',
            defaultVatType: 'Predvolený typ DPH',
        },
        invoiceSettings: {
            title: 'Nastavenia faktúry',
            description: 'Logo zobrazené na PDF faktúrach.',
        },
        deleteAccount: {
            title: 'Zmazať účet',
            description: 'Po zmazaní účtu sa natrvalo odstránia všetky súvisiace údaje. Pred zmazaním si prosím stiahnite údaje, ktoré chcete zachovať.',
            button: 'Zmazať účet',
            confirmTitle: 'Naozaj chcete zmazať účet?',
            confirmDescription: 'Po zmazaní účtu sa natrvalo odstránia všetky údaje. Zadajte heslo na potvrdenie trvalého zmazania účtu.',
            passwordPlaceholder: 'Heslo',
        },
        password: {
            title: 'Zmena hesla',
            description: 'Používajte dlhé, náhodné heslo pre väčšiu bezpečnosť.',
            current: 'Aktuálne heslo',
            new: 'Nové heslo',
        },
        info: {
            title: 'Údaje profilu',
            description: 'Aktualizujte meno a e-mail vášho účtu.',
            emailUnverified: 'Vaša e-mailová adresa nie je overená.',
            resendVerification: 'Kliknutím znova odošlete overovací e-mail.',
            verificationSent: 'Nový overovací odkaz bol odoslaný na vašu e-mailovú adresu.',
        },
    },
    welcome: {
        headTitle: 'Invoicius – jednoduchá fakturácia',
        login: 'Prihlásiť sa',
        hero: {
            titleLine1: 'Faktúry, klienti',
            titleLine2: 'a automatizácie',
            titleHighlight: 'na jednom mieste',
            subtitle: 'Vytvárajte faktúry, spravujte klientov a automatizujte opakujúce sa úlohy – bez zbytočného klikania.',
            cta: 'Prihlásiť sa do aplikácie',
            tagline: 'Jednoduchá fakturácia · DPH · PDF export · Automatizácie',
            screenshotAlt: 'Ukážka aplikácie Invoicius',
            slideAriaLabel: 'Snímka {n}',
        },
        trust: {
            invoiceReady: 'Faktúra hotová za 2 minúty',
            localization: 'Viac mien a jazykov',
            pdfExport: 'Export faktúr kedykoľvek',
            automation: 'Automatizácie bežia non-stop',
        },
        features: {
            title: 'Všetko čo potrebujete k fakturácii',
            subtitle: 'Žiadne zbytočné funkcie. Len to, čo každý deň skutočne využijete.',
            invoices: {
                title: 'Faktúry',
                description: 'Vystavte faktúru za minútu. Sledujte každý stav – od konceptu až po uhradenie.',
                item1: 'Export do PDF kedykoľvek',
                item2: 'Položky s DPH a zľavami',
                item3: 'Stav platby v reálnom čase',
            },
            clients: {
                title: 'Klienti',
                description: 'Správa klientov vrátane IČO, DIČ, adresy a kompletnej histórie fakturácie.',
                item1: 'Kompletné fakturačné údaje',
                item2: 'História faktúr podľa klienta',
                item3: 'Celkový obrat na jednom mieste',
            },
            automatizations: {
                title: 'Automatizácie',
                description: 'Nastavte raz, systém funguje za vás – mesačné faktúry, reporty, pripomienky.',
                item1: 'Automatické generovanie faktúr',
                item2: 'Mesačné reporty e-mailom',
                item3: 'Pripomienky pred splatnosťou',
            },
        },
        cta: {
            titleLine1: 'Začnite',
            titleLine2: 'fakturovať',
            titleHighlight: 'dnes',
            description: 'Prihláste sa a spravujte svoju fakturáciu prehľadne, rýchlo a bez zbytočného klikania.',
            button: 'Prihlásiť sa',
            tileInvoiceReady: 'Faktúra za 2 minúty',
            tileLocalization: 'Viac mien a jazykov',
            tilePdfExport: 'Export kedykoľvek',
            tileAutomation: 'Automatizácie non-stop',
        },
        footer: 'Invoicius · 2026',
    },
    units: {
        pcs: 'ks',
        hrs: 'hod',
        days: 'dni',
        kg: 'kg',
        m: 'm',
        m2: 'm²',
    },
    vatType: {
        mimo: 'Mimo DPH',
        osvo: 'Oslobodené od DPH',
    },
    currency: {
        '€': 'Euro',
        'Kč': 'Česká koruna',
        '$': 'Americký dolár',
    },
} as const;
